// Remembers that the greeting bubble was dismissed (closed, or the chat opened)
// so it doesn't reappear on every load. Per-browser convenience only.
export const CALLOUT_DISMISSED_STORAGE_KEY = 'lms.policyAssistant.calloutDismissed'

export function readCalloutDismissed(): boolean {
  try {
    return window.localStorage.getItem(CALLOUT_DISMISSED_STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

export function persistCalloutDismissed(): void {
  try {
    window.localStorage.setItem(CALLOUT_DISMISSED_STORAGE_KEY, 'true')
  } catch {
    // localStorage may throw in private mode; the dismissal still holds in-memory.
  }
}
